import { Link, useLocation } from "react-router-dom";

const ROUTE_LABELS = {
    "about-us": "About Us",
    "contact-us": "Contact Us",
    faq: "FAQ",
    products: "Shop",
    product: "Product",
    blog: "Blog",
    "privacy-policy": "Privacy Policy",
    "terms-conditions": "Terms & Conditions",
    cart: "Cart",
    checkout: "Checkout",
    wishlist: "Wishlist",
    login: "Login",
    register: "Register",
    "forgot-password": "Forgot Password",
    myprofile: "My Profile",
    myorder: "Your Orders",
    "shipping-address": "Shipping Address",
    "cancel-order": "Cancel Order",
    paymentreturn: "Payment Return",
    returnandrefundpolicy: "Refund & Return Policy",
};

const formatSegmentLabel = (segment) => {
    if (!segment) {
        return "Home";
    }

    const normalizedSegment = decodeURIComponent(segment).toLowerCase();

    if (ROUTE_LABELS[normalizedSegment]) {
        return ROUTE_LABELS[normalizedSegment];
    }

    return decodeURIComponent(segment)
        .replace(/[_-]+/g, " ")
        .replace(/\b\w/g, (character) => character.toUpperCase());
};

const buildItemsFromPath = (pathname, currentLabel) => {
    const segments = pathname.split("/").filter(Boolean);

    if (segments.length === 0) {
        return [{ label: "Home", path: "/" }];
    }

    const items = [{ label: "Home", path: "/" }];

    segments.forEach((segment, index) => {
        if (/^\d+$/.test(segment)) {
            return;
        }

        const isLastItem = index === segments.length - 1;

        items.push({
            label: isLastItem && currentLabel ? currentLabel : formatSegmentLabel(segment),
            path: `/${segments.slice(0, index + 1).join("/")}`,
        });
    });

    return items;
};

const Breadcrumb = ({ items, currentLabel, className = "" }) => {
    const location = useLocation();
    const breadcrumbItems =
        Array.isArray(items) && items.length > 0
            ? items
            : buildItemsFromPath(location.pathname, currentLabel);

    return (
        <ol className={`breadcrumb ${className}`.trim()}>
            {breadcrumbItems.map((item, index) => {
                const isLastItem = index === breadcrumbItems.length - 1;

                return (
                    <li
                        key={`${item.path || item.label}-${index}`}
                        className={isLastItem ? "active" : ""}
                    >
                        {isLastItem || !item.path ? (
                            <span>{item.label}</span>
                        ) : (
                            <Link to={item.path}>{item.label}</Link>
                        )}
                    </li>
                );
            })}
        </ol>
    );
};

export { buildItemsFromPath, formatSegmentLabel };
export default Breadcrumb;
